import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from '@/layout/index.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        component: AppLayout,
        meta: { title: '首页', icon: 'cd_gntb_sy.png' },
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/home/index.vue'),
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        meta: { notLogin: true },
    },
    {
        path: '/manage',
        component: AppLayout,
        meta: { title: '健康管理', icon: 'cd_gntb_jkgl.png' },
        children: [
            {
                path: '/manage/sport',
                name: 'sport',
                component: () => import('@/views/manage/sport/index.vue'),
                meta: { title: '运动监测', icon: 'sy_fwtb_ydjc.png', keepAlive: true },
            },
            {
                path: '/manage/sport/studentInfo',
                name: 'sportStudentInfo',
                component: () => import('@/views/manage/sport/studentInfo.vue'),
                meta: { activeMenu: '/manage/sport' },
            },
            {
                path: '/manage/sleep',
                name: 'sleep',
                component: () => import('@/views/manage/sleep/index.vue'),
                meta: { title: '睡眠记录', icon: 'sy_fwtb_smjl.png', keepAlive: true }
            },
            {
                path: '/manage/sleep/classInfo',
                name: 'sleepClassInfo',
                component: () => import('@/views/manage/sleep/classInfo.vue'),
                meta: { activeMenu: '/manage/sleep' },
            },
            {
                path: '/manage/sleep/studentInfo',
                name: 'sleepStudentInfo',
                component: () => import('@/views/manage/sleep/studentInfo.vue'),
                meta: { activeMenu: '/manage/sleep' },
            },
            {
                path: '/manage/walk',
                name: 'walk',
                component: () => import('@/views/manage/walk/index.vue'),
                meta: { title: '每日步数', icon: 'sy_fwtb_mrbs.png' }
            },
            {
                path: '/manage/walk/classInfo',
                name: 'walkClassInfo',
                component: () => import('@/views/manage/walk/classInfo.vue'),
                meta: { activeMenu: '/manage/walk' },
            },
            {
                path: '/manage/walk/studentInfo',
                name: 'walkStudentInfo',
                component: () => import('@/views/manage/walk/studentInfo.vue'),
                meta: { activeMenu: '/manage/walk' },
            },
            {
                path: '/manage/active',
                name: 'active',
                component: () => import('@/views/manage/active/index.vue'),
                meta: { title: '兴趣角活动', icon: 'sy_fwtb_qyhdjc.png' }
            },
            {
                path: '/manage/active/classInfo',
                name: 'activeClassInfo',
                component: () => import('@/views/manage/active/classInfo.vue'),
                meta: { activeMenu: '/manage/active', keepAlive: true },
            },
            {
                path: '/manage/active/studentInfo',
                name: 'activeStudentInfo',
                component: () => import('@/views/manage/active/studentInfo.vue'),
                meta: { activeMenu: '/manage/active' },
            },
            {
                path: '/manage/active/settings',
                name: 'activeSettings',
                component: () => import('@/views/manage/active/settings.vue'),
                meta: { activeMenu: '/manage/active' },
            },
            {
                path: '/manage/health',
                name: 'health',
                component: () => import('@/views/manage/health/index.vue'),
                meta: { title: '实时健康监测', icon: 'sy_ssfwtb_jkjc.png' }
            },
        ]
    },
    {
        path: '/growth',
        component: AppLayout,
        meta: { title: '成长记录', icon: 'cd_gntb_czjl.png' },
        children: [
            {
                path: '/growth/record',
                name: 'growthRecord',
                component: () => import('@/views/growth/record/index.vue'),
                meta: { title: '园所记录', icon: 'sy_fwtb_ysjl.png' }
            },
            {
                path: '/growth/record/detail',
                name: 'growthRecordDetail',
                component: () => import('@/views/growth/record/detail.vue'),
                meta: { title: '园所记录详情', activeMenu: '/growth/record' }
            },
            {
                path: '/growth/behavior',
                name: 'growthBehavior',
                component: () => import('@/views/growth/behavior/index.vue'),
                meta: { title: '行为记录', icon: 'sy_fwtb_xwjl.png' }
            },
            {
                path: '/growth/behavior/edit_gcjl',
                name: 'growthaAddEdit',
                component: () => import('@/views/growth/behavior/edit_gcjl.vue'),
                meta: { title: '行为记录', activeMenu: '/growth/behavior' }
            },
            {
                path: '/growth/behavior/addCustom',
                name: 'growthaAddCustom',
                component: () => import('@/views/growth/behavior/addCustom.vue'),
                meta: { title: '管理园所自建表现行为', activeMenu: '/growth/behavior' }
            },
            {
                path: '/growth/reports',
                name: 'growthReports',
                component: () => import('@/views/growth/reports/index.vue'),
                meta: { title: '报告管理', icon: 'sy_fwtb_bggl.png' },
            },
            {
                path: '/growth/reports/classInfo',
                name: 'growthReportsClassInfo',
                component: () => import('@/views/growth/reports/classInfo.vue'),
                meta: { title: '报告管理', activeMenu: '/growth/reports' },
            },
            {
                path: '/growth/reports/studentInfo',
                name: 'growthReportsStudentInfo',
                component: () => import('@/views/growth/reports/studentInfo.vue'),
                meta: { title: '报告管理', activeMenu: '/growth/reports' },
            },
        ]
    },
    {
        path: '/settings',
        component: AppLayout,
        meta: { title: '基础管理', icon: 'cd_gntb_jcsz.png' },
        children: [
            {
                path: '/settings/classList',
                name: 'settingClass',
                component: () => import('@/views/settings/user/classList.vue'),
                meta: { title: '班级管理', icon: 'sy_fwtb_bjgl.png' }
            },
            {
                path: '/settings/teacherList',
                name: 'settingTeacher',
                component: () => import('@/views/settings/user/teacherList.vue'),
                meta: { title: '教师管理', icon: 'sy_fwtb_jsgl.png' }
            },
            {
                path: '/settings/studentList',
                name: 'settingStudent',
                component: () => import('@/views/settings/user/studentList.vue'),
                meta: { title: '学生管理', icon: 'sy_fwtb_xsgl.png' }
            },
            {
                path: '/settings/braceletList',
                name: 'settingBracelet',
                component: () => import('@/views/settings/user/braceletList.vue'),
                meta: { title: '手环管理', icon: 'sy_fwtb_shgl.png' }
            },
            {
                path: '/settings/school',
                name: 'settingSchool',
                component: () => import('@/views/settings/user/school.vue'),
                meta: { title: '学校管理', icon: 'sy_fwtb_xxgl.png' }
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '云慧玩'
    if (!to.meta.notLogin) {
        let token = localStorage.getItem('token')
        if (token) {
            next()
        } else {
            next({
                path: '/login',
            })
        }
    } else {
        next()
    }
})

export default router

